/* Reads data from excel file and renders chart useing the Google Charts API */

Librarian.Modules.Graph = new Class({
    Extends: Librarian.Modules.Module, 
    Binds: ["googleChartsLibraryLoaded", "getChartOptions", "getChartData", "drawChart"],

    wrapperEl: null,

    options: {
        classPrefix: "modules-graph-",
        dataFile: null, 
        graphType: null,
        id: null,

        // chart style options
        label: null,
        width: null, 
        height: null, 
        backgroundColor: null, 
        textColor: null,
    },

    initialize: function(options, wrapperEl) {
        this.setOptions(options);

        this.wrapperEl = wrapperEl;
        this.options.graphType = this.options.graphType.toLowerCase();
        this.options.chartLabel = this.options.label;
        this.options.label = null;
        this.data = null;

        this.parent(this.options, wrapperEl, null, function() {
            // called when module is loaded (prevents drawing of chart before element is in DOM) 

            if($("google-charts-library")) {
                // library already loaded
                this.googleChartsLibraryLoaded();
            } else {
                // dynamicaly load google charts source files
                this.loadScript("https://www.gstatic.com/charts/loader.js", this.googleChartsLibraryLoaded);
            }

            // set name to apply CSS rule to all graph modules
            wrapperEl.set("name", "module_graph_" + this.options.id);
        });
   
    }, 

    loadScript: function(src, callback) {
        // create new script element and append to head
        var headEl = document.getElementsByTagName("head")[0];
        var newScript = document.createElement("script");

        newScript.id = "google-charts-library";
        newScript.type = "text/javascript";
        newScript.src = src;
        newScript.onload = callback;
        headEl.appendChild(newScript);
    },

    googleChartsLibraryLoaded: function() {

        var self = this;

        try{
            // load google chart packages
            google.charts.load('current', { 'packages': ['corechart', 'line'] });

            // run callback when packages finish loading
            google.charts.setOnLoadCallback(self.getChartData);

        } catch(event) {

            if(event.name == "ReferenceError") {
                // this can happen when two graph modules are loaded at the same time
                // the charts loader script element is set, but has not finished loading
                setTimeout(function() {
                    self.googleChartsLibraryLoaded();
                }, 250);
            }

        }

    },

    getChartData: function() {

        var self = this;
        var url = "default.ashx?m=getslidetext&out=ujson&snum=1&fname=" + this.options.dataFile;
        var request = new XMLHttpRequest();

        request.onreadystatechange = function() {
            if (request.readyState == 4 && request.status == 200) {

                // parse json
                var content = Librarian.Utils.getArrayFromCSV(JSON.parse(request.responseText).Text);

                // convert values from string to numbers
                content.forEach(function(item, index) {
                    if(index === 0) { return; }
                    content[index][1] = Number(content[index][1]);
                });

                // feed data to google charts
                self.data = new google.visualization.DataTable();
                self.data.addColumn("string", content[0][0]);
                self.data.addColumn("number", content[0][1]);
                self.data.addRows(content.slice(1, content.length));

                // draw chart
                self.drawChart(); 
            }
        };

        request.open("GET", url, true);
        request.send(null);

    },

    getChartOptions: function() {

        //TODO: add json file option to load chart options from file

        // set configurable options set in layout xml file
        var chartLabel = this.options.chartLabel || "",
            backgroundColor = this.options.backgroundColor || "transparent",
            textColor = this.options.textColor || "#fff",
            width = this.options.width || 320,
            height = this.options.height || 320;

        return { 
            // configurable options
            'title': chartLabel,
            'backgroundColor': { 'fill': backgroundColor },
            'width': width,
            'height': height,

            'titleTextStyle': {
                'color': textColor, 
                'fontSize': '37',
                'fontName': 'Roboto',
                'bold': false,
            },

            'hAxis': {
                'textStyle': { 'color': textColor }
            },

            'vAxis': {
                'textStyle': { 'color': textColor }
            },

            // non-configurable options
            'legend': 'none',
            'is3D': true,
        };

    },

    drawChart: function() {

        // used to resovle string of graphType to constructor
        var graphTypes = {
            piechart: google.visualization.PieChart, 
            barchart: google.visualization.BarChart,
            columnchart: google.visualization.ColumnChart,
        };

        // set chart settings
        var chartOptions = this.getChartOptions();

        // draw graph 
        var chartConstructor = graphTypes[this.options.graphType];

        if(!chartConstructor) {
            Librarian.Utils.log("Graph Module Error: Invalid graphType value");
            return;
        }

        var chart = new chartConstructor(this.wrapperEl);
        chart.draw(this.data, chartOptions);
    
    }

});

